module.exports = __webpack_public_path__ + "static/1328365317.5ba01b53.jpg";